import { ArrowRight, Phone, Star } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/0a4872c7-0ac7-41c4-a84c-97ee9bda904d/images/33f1ca56dc7e157c8b1db0ad334b9f225a47c70a9790ad6b3ca2f8d28ec4d16b.png"
          alt="Heavy iron weights in a dark gym"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60" />
      </div>

      <div className="relative container-x w-full px-6 md:px-12 pt-28 pb-20">
        <div className="max-w-4xl reveal">
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 border border-[#FF3B30]/40 bg-[#FF3B30]/10 px-4 py-2 mb-8 backdrop-blur-sm"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B30] animate-pulse" />
            <span className="text-[11px] tracking-[0.25em] uppercase text-white font-bold">
              Free First Session · New Clients
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-[14vw] md:text-[9vw] lg:text-[7.5rem] leading-[0.85] uppercase tracking-tight"
          >
            Train with
            <br />
            <span className="text-[#FF3B30]">purpose.</span> Push
            <br />
            your limits.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 text-base md:text-xl text-white/70 max-w-2xl leading-relaxed"
          >
            Try a <span className="text-white font-semibold">free first session</span> with Coach Manny —
            1-on-1 personal training, private lessons, soccer coaching, or online programs built around your goals.
            Patient. Relentless. Proven. Caldwell, ID.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#book" data-testid="hero-cta-primary" className="btn-primary">
              Claim Free Session <ArrowRight size={16} />
            </a>
            <a
              href="tel:+12089019386"
              data-testid="hero-cta-secondary"
              className="btn-secondary"
            >
              <Phone size={16} /> (208) 901-9386
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3">
            <div className="flex items-center gap-1 text-[#FF3B30]">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <span className="text-xs tracking-[0.2em] uppercase text-white/60">
              5.0 · 16 Google Reviews
            </span>
          </div>

          <div className="mt-14 grid grid-cols-3 max-w-xl gap-6 pt-6 border-t border-white/10">
            {[
              { k: "5.0", v: "Google rating" },
              { k: "100%", v: "Personalised" },
              { k: "All", v: "Levels welcome" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-display text-3xl md:text-4xl text-white">
                  {s.k}
                </div>
                <div className="text-[11px] tracking-widest uppercase text-white/50 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 hidden md:block text-[11px] tracking-[0.3em] uppercase text-white/40 rotate-90 origin-bottom-right">
        Caldwell · Idaho
      </div>
    </section>
  );
}
